import React, { useState, useEffect } from 'react';
import {
  Card, Col, Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import ProfileActivities from './ProfileActivities';
import showResults from './Show';
import ProfileSettings from './ProfileSettings';
import UserDocuments from './UserDocuments';
import DoctorFees from './DoctorFees';

const ProfileTabs = () => {
  const [activeTab, setActiveTab] = useState('1');
  const user = JSON.parse(sessionStorage.getItem('usuario'));

  const typeProfile = parseInt(sessionStorage.getItem('perfil'));

  const handleToggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <Col md={12} lg={12} xl={8}>
      <Card>
        <div className="profile__card tabs tabs--bordered-bottom">
          <div className="tabs__wrap">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '1' })}
                  onClick={() => handleToggle('1')}
                >
                  Configuración
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '2' })}
                  onClick={() => handleToggle('2')}
                >
                  Documentos
                </NavLink>
              </NavItem>
              {
                typeProfile == 10 ? <>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => handleToggle('3')}
                    >
                      Honorarios
                    </NavLink>
                  </NavItem>
                </> : null
              }

            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <ProfileSettings />
              </TabPane>
              <TabPane tabId="2">
                <UserDocuments id_usuario={user.id_usuario} permissionUpload={true} />
              </TabPane>
              <TabPane tabId="3">
                {
                  typeProfile == 10 ? <DoctorFees /> : null
                }
              </TabPane>
            </TabContent>
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default ProfileTabs;
